var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.3125,
    width: 60,
    height: 60,
    rx: 0,
    fill: "#006DF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 31.249C28.0368 31.9666 28.7217 32.5605 29.5082 32.9902C30.2947 33.4199 31.1644 33.6754 32.0583 33.7394C32.9522 33.8034 33.8495 33.6744 34.6892 33.3612C35.5289 33.048 36.2914 32.5578 36.925 31.924L40.675 28.174C41.8135 26.9952 42.4435 25.4165 42.4292 23.7777C42.415 22.139 41.7577 20.5714 40.5989 19.4126C39.4401 18.2538 37.8725 17.5965 36.2338 17.5823C34.595 17.568 33.0163 18.198 31.8375 19.3365L29.6875 21.474",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4998 28.7486C31.9629 28.0309 31.2781 27.4371 30.4916 27.0074C29.7051 26.5777 28.8354 26.3222 27.9414 26.2582C27.0475 26.1941 26.1503 26.3231 25.3106 26.6363C24.4709 26.9496 23.7084 27.4397 23.0748 28.0736L19.3248 31.8236C18.1863 33.0023 17.5563 34.5811 17.5705 36.2198C17.5848 37.8586 18.2421 39.4261 19.4009 40.5849C20.5597 41.7437 22.1273 42.401 23.766 42.4153C25.4047 42.4295 26.9835 41.7996 28.1623 40.6611L30.2998 38.5236",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.80b9e9b6bd934d1fd72881e3d13b5325.svg";
export { ForwardRef as ReactComponent };